import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AppLayout } from "../../../layout/AppLayout";
import { motion } from "framer-motion";
import { Arrow } from "../../svg/Wallet/Wallet";
import OTPInput from "../../input/OTPInput";
import { Card } from "../../Card";
import { Check } from "../../svg/Auth/Auth";
import { CustomPinInput } from "../../input/CustomPinInput";
import Button from "../../button/Button";
import { useSecurity } from "../../../api/settings/security";
import { Loader } from "../../loader/Loader";
import clsx from "clsx";

const ForgotTransactionPin = () => {
  const navigate = useNavigate();
  const {
    handleResetPin,
    canChangePin,
    setOtp,
    pin,
    setPin,
    loading,
    otp,
    handleGetOtp,
    handleValidatetOtp,
    gettingOtp,
    setConfirmPin,
    confirmPin,
    validating,
  } = useSecurity();

  const handleCallResetPin = async () => {
    const success = await handleResetPin();
    if (success) {
      navigate("/settings/secure/transaction-pin");
    }
  };

  useEffect(() => {
    if (otp.length === 4) {
      handleValidatetOtp();
    }
  }, [otp]);

  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <div className="pt-10 pb-7 px-5 min-h-screen flex flex-col">
        <motion.div
          initial={{ opacity: 0, scale: 0.2 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.6,
            ease: [0.25, 0.46, 0.45, 0.94],
          }}
          className="w-full relative flex flex-col flex-grow"
        >
          <div className="relative flex items-center justify-center mb-10">
            <Arrow
              onClick={() => navigate(-1)}
              stroke="#fff"
              className="text-lg absolute left-0 cursor-pointer"
            />
            <p className="font-bold text-xl text-black">Set transaction pin</p>
          </div>
          <Card className="mb-5">
            <p className="text-primary-black text-sm font-normal text-center ">
              Enter the OTP sent to your{" "}
              <span className="font-medium">email address</span>
            </p>
            <OTPInput getPin={(val) => setOtp(val)} />
            <div className="flex items-center justify-between mt-5">
              {canChangePin ? (
                <div className="flex items-center gap-1.5">
                  <Check />
                  <p className="text-xs text-black">Code verified</p>
                </div>
              ) : validating ? (
                <Loader
                  width={"35px"}
                  height={"20px"}
                  color={"#2741D6"}
                  type="bubbles"
                />
              ) : (
                <span></span>
              )}

              {gettingOtp ? (
                <Loader
                  width={"35px"}
                  height={"20px"}
                  color={"#2741D6"}
                  type="bubbles"
                />
              ) : (
                <button
                  onClick={handleGetOtp}
                  className="text-primary-main text-xs"
                >
                  Resend OTP
                </button>
              )}
            </div>
          </Card>

          {canChangePin && (
            <>
              <Card>
                <div className="mb-4">
                  <p className="text-sm text-primary-black mb-3.5 font-normal">
                    New pin
                  </p>
                  <CustomPinInput
                    pin={pin}
                    onPinChange={setPin}
                    autoFocus={true}
                  />
                </div>
                <div>
                  <p className="text-sm text-primary-black mb-3.5 font-normal">
                    Confirm pin
                  </p>
                  <CustomPinInput
                    pin={confirmPin}
                    onPinChange={setConfirmPin}
                    autoFocus={true}
                  />
                </div>
              </Card>
              <Button
                onClick={handleCallResetPin}
                text={loading ? <Loader type="bubbles" /> : "Confrim"}
                className={clsx(loading && "!py-0")}
              />
            </>
          )}
        </motion.div>
      </div>
    </AppLayout>
  );
};

export default ForgotTransactionPin;
